import React from "react";
import { useLang } from "@/context/LanguageContext";

export const Marquee = ({ variant = "vision", reverse = false }) => {
  const { t } = useLang();
  const raw = variant === "roles" ? t.rolesMarquee : t.marquee;
  const text = raw.repeat(2);
  return (
    <div
      data-testid={variant === "roles" ? "roles-marquee" : "editorial-marquee"}
      className={`border-b border-white/10 py-8 overflow-hidden select-none ${reverse ? "" : "border-t"}`}
    >
      <div className={`marquee-track ${reverse ? "marquee-reverse" : ""}`}>
        <span className="font-serif-display italic text-3xl md:text-5xl text-zinc-500 tracking-wide pr-8">
          {text}
        </span>
        <span className="font-serif-display italic text-3xl md:text-5xl text-zinc-500 tracking-wide pr-8" aria-hidden="true">
          {text}
        </span>
      </div>
    </div>
  );
};
